const strings = {
  TITLE: 'Titel',
  TITLE_ENGLISH: 'Titel (engelska)',
  INFORMATION: {
    email: 'Emailadress',
    phone: 'Telefonnummer',
    url: 'Hemsida',
    text: 'Information'
  },
  INFORMATION_ENGLISH: 'Information (engelska)',
  CANCEL: 'Avbryt',
  DONE: 'Klar',
  PHONE_NUMBER: 'Telefonnummer',
  EMAIL: 'Emailadress',
  URL: 'Hemsida',
  PLAIN_TEXT: 'Text'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/common/InformationModal/strings.js